export default __webpack_public_path__ + "static/media/Banquet_and_event_halls.9b758212.jpg";